/* import __COLOCATED_TEMPLATE__ from './categories-and-latest-topics.hbs'; */
import Component from "@ember/component";
import { classNames } from "@ember-decorators/component";

@classNames("categories-and-latest")
export default class CategoriesAndLatestTopics extends Component {}
